/* eslint import/prefer-default-export: 0 */

// dependencies
import { toDate, parse, parseISO } from "date-fns";
import { fromJS } from "immutable";
import useragentParser from "ua-parser-js";
import { CreateProcess } from "redux-process";
import moment from "moment";

// utils
import objectToQueryString from "Utils/objectToQueryString";

// selectors
import { getCurrentEnvironmentName } from "Selectors/app";

export const GetUsers = CreateProcess({
	method: "GET",
	name: "GetUsers",
	type: "USERS:GET",

	request: (props, { getState }) => {
		const state = getState();
		const environment = getCurrentEnvironmentName(state);

		const queryString = objectToQueryString(props);

		return {
			url: `/${environment}/users/?${queryString}`,
		};
	},

	success: (response) => {
		const data = fromJS(response.data.items);

		return data.withMutations((mutable) => {
			data.forEach((item, ii) => {
				mutable.setIn([ii, "companyID"], item.get("company"));
				mutable.deleteIn([ii, "company"]);
			});
		});
	},
});

export const GetUsersSearch = CreateProcess({
	method: "GET",
	name: "GetUsersSearch",
	type: "USERS:SEARCH",

	request: (props, { getState }) => {
		const state = getState();
		const environment = getCurrentEnvironmentName(state);

		const queryString = objectToQueryString(props);

		return {
			url: `/${environment}/search/users/?${queryString}`,
		};
	},

	success: (response) => {
		const data = fromJS(response.data.items);

		return data.withMutations((mutable) => {
			data.forEach((item, ii) => {
				mutable.setIn([ii, "companyID"], item.get("company"));
				mutable.deleteIn([ii, "company"]);
			});
		});
	},
});

export const GetOne = CreateProcess({
	method: "GET",
	name: "GetOneUser",
	type: "USERS:GETONE",

	request: (props, { getState }) => {
		const { userID } = props;
		const state = getState();
		const environment = getCurrentEnvironmentName(state);

		return {
			url: `/${environment}/users/${userID}`,
		};
	},

	success: (response) => {
		const data = fromJS(response.data);

		return data.withMutations((mutable) => {
			mutable.setIn(["companyID"], data.get("company"));
			mutable.deleteIn(["company"]);
			mutable.setIn(["lastSeen"], data.get("lastSeen", null) ? moment(data.get("lastSeen")) : null);
		});
	},
});

export const GetRecentUsers = CreateProcess({
	method: "GET",
	name: "GetRecentUsers",
	type: "USERS:RECENT",

	request: (props, { getState }) => {
		const state = getState();
		const environment = getCurrentEnvironmentName(state);
		const queryString = objectToQueryString(props);

		return {
			url: `/${environment}/recent-users/?${queryString}`,
		};
	},

	success: (response) => {
		let data = fromJS(response.data);

		data = data.withMutations((mutable) => {
			data.get("recentUsers").forEach((user, ii) => {
				const requestEndTime = toDate(user.getIn(["last_request", "end_time"]) * 1000);
				const requestStartTime = toDate(user.getIn(["last_request", "start_time"]) * 1000);
				const parsedUserAgent = useragentParser(user.getIn(["last_request", "user_agent"]));
				const deltaTime = user.getIn(["last_request", "end_time"]) - user.getIn(["last_request", "start_time"]);

				mutable.setIn(["recentUsers", ii, "endTime"], requestEndTime);
				mutable.setIn(["recentUsers", ii, "startTime"], requestStartTime);
				mutable.setIn(["recentUsers", ii, "deltaTime"], deltaTime * 1000);
				mutable.setIn(["recentUsers", ii, "lastRequest"], mutable.getIn(["recentUsers", ii, "last_request"]));
				mutable.setIn(["recentUsers", ii, "lastRequest", "userAgentParsed"], fromJS(parsedUserAgent));

				mutable.deleteIn(["recentUsers", ii, "start_time"]);
				mutable.deleteIn(["recentUsers", ii, "last_request"]);
				mutable.deleteIn(["recentUsers", ii, "last_request", "user_agent"]);
			});
		});

		return data;
	},
});

export const GetRecentlyDeactivatedUsers = CreateProcess({
	method: "GET",
	name: "GetRecentlyDeactivatedUsers",
	type: "USERS:DEACTIVATED",

	request: (props, { getState }) => {
		const state = getState();
		const environment = getCurrentEnvironmentName(state);
		const queryString = objectToQueryString(props);

		return {
			url: `/${environment}/recently-deactivated/?${queryString}`,
		};
	},

	success: (response) => {
		const data = fromJS(response.data.deactivatedUsers);
		return data;
	},
});

export const fetchUpcomingNotifications = CreateProcess({
	method: "GET",
	name: "fetchUpcomingNotifications",
	type: "fetch upcoming notifications",

	request: (props, { getState }) => {
		const { userID, type } = props;

		const state = getState();
		const environment = getCurrentEnvironmentName(state);

		return {
			url: `/${environment}/users/${userID}/notifications/${type}`,
		};
	},

	success: (response) => {
		const { data } = response;

		data.notifications.forEach((notification) => {
			console.log(notification);
			notification.not_after = notification.not_after ? parseISO(notification.not_after) : notification.not_after;
			notification.not_before = parseISO(notification.not_before);
		});

		return data;
	},
});
